import CardCredentialIdentityScreen from 'features/cardManagement/screens/cardCredentialChallenge/CardCredentialIdentityScreen/CardCredentialIdentityScreen';
import React from 'react';

export default function BelieveFundingP2PCardCredentialIdentityPage() {
  return (
    <CardCredentialIdentityScreen
      otpPath="/believe-funding/p2p/credential-challenge/[cardId]/verify-otp"
      returnPath="/believe-funding/p2p/debit"
      errorReturnToCardDetail
    />
  );
}
